var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConfidential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 73.3 81.5",
    style: {
      enableBackground: "new 0 0 73.3 81.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#4C54F3;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_621",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_985"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.6,27c-2.4-0.1-4.8,0.7-6.6,2.3c-1.8,1.6-2.9,3.9-3,6.4c0,2.8,1.4,5.4,3.6,6.9v10.9h11V42.7 c2.2-1.6,3.6-4.2,3.6-6.9v-0.1C46,31,42.3,27.3,37.6,27z M40.8,40.9l-0.6,0.4v9.8h-6v-9.8l-0.6-0.4c-1.8-1.1-3-3.1-3-5.1 c0.1-1.8,0.9-3.4,2.2-4.6c1.3-1.2,3-1.8,4.8-1.7c3.4,0.2,6.1,2.8,6.3,6.2C43.7,37.9,42.6,39.8,40.8,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.7,4.8h-68c-1.1,0-2,0.9-2,2v68c0,1.1,0.9,2,2,2h68c1.1,0,2-0.9,2-2v-68C72.7,5.7,71.8,4.8,70.7,4.8z  M69.7,73.7h-66v-66h66V73.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.7,4.8h-68c-1.1,0-2,0.9-2,2v68c0,1.1,0.9,2,2,2h68c1.1,0,2-0.9,2-2v-68C72.7,5.7,71.8,4.8,70.7,4.8z  M69.7,73.7h-66v-66h66V73.7z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_1332"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.7,25.6c-2.6-0.1-5.3,0.8-7.3,2.5s-3.2,4.3-3.3,7.1c0,3.1,1.5,6,4,7.6v12h12.1V43c2.4-1.8,4-4.6,4-7.6v-0.1 C46.9,30.1,42.8,26,37.7,25.6z M41.2,41l-0.7,0.4v10.8h-6.6V41.4L33.2,41c-2-1.2-3.3-3.4-3.3-5.6c0.1-2,1-3.7,2.4-5.1 c1.4-1.3,3.3-2,5.3-1.9c3.7,0.2,6.7,3.1,6.9,6.8C44.4,37.7,43.2,39.8,41.2,41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfidential);
export default __webpack_public_path__ + "static/media/_icon_confidential.04611aff197b5aff872d37f91eef45fd.svg";
export { ForwardRef as ReactComponent };